import type { Agency } from '@/api';

export const useAgencyPolicy = (app: Ref<Agency | undefined>) => {
    const { authorized_branches, isAgency, isSchool, permissions } = useCompany();
    const getPolicy = (agency: Agency | undefined) => {
        const update =
            (isAgency &&
                permissions.value.editAgencyBranches &&
                authorized_branches.value?.some(a => a.id === agency?.company_branch_id)) ||
            permissions.value.manageAgencies ||
            agency?.can?.update;

        return {
            update,
        } as const;
    };

    const policy = computed(() => getPolicy(app.value));

    return { policy, getPolicy };
};
